/**
 * calc distance between two points
 * @param {{x: Number, y: Number}} point1 
 * @param {{x: Number, y: Number}} point2 
 */
export function distanceBetweenPoints(point1, point2) {
    console.log("x:", point1.x - point2.x);
    console.log("y:", point1.y - point2.y)
    return Math.sqrt((point1.x - point2.x) ** 2 + (point1.y - point2.y) ** 2);
}